<template>
    <div class="application--wrap centered-content">
        <v-content>
            <v-layout fill-height>
                <v-container>
                    <div class="welcome-section">
                        <div class="welcome-logo mb-4">
                            <img src="@/assets/images/logo.svg" alt="E-Connectz">
                        </div>
                    </div>
                </v-container>
            </v-layout>
        </v-content>
        <v-footer transparent height="auto" class="white--text">
            <v-container>
                <v-layout column>
                    <p class="text-xs-center">Ga verder met</p>
                    <v-btn
                            class="white--text"
                            block
                            large
                            depressed
                            color="primary"
                            @click="gotoLogin">
                        Inloggen
                    </v-btn>
                    <v-btn
                            block
                            large
                            depressed
                            :outline="true"
                            color="white"
                            @click="gotoRegister">
                        Registreren
                    </v-btn>
                </v-layout>
            </v-container>
        </v-footer>
    </div>
</template>

<script>
export default {
  name: 'welcome-page',
  methods: {
    gotoLogin() {
      this.$router.push('login');
    },
    gotoRegister() {
      this.$router.push('register');
    },
  },
};
</script>

<style lang="stylus">
    .welcome-section
        padding: 2rem
        text-align: center

    .welcome-logo img
        display: block
        width: 100%

</style>
